import { render, staticRenderFns } from "./go-play.vue?vue&type=template&id=b607b53c&scoped=true&"
import script from "./go-play.vue?vue&type=script&lang=js&"
export * from "./go-play.vue?vue&type=script&lang=js&"
import style0 from "./go-play.vue?vue&type=style&index=0&id=b607b53c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b607b53c",
  null
  
)

export default component.exports